import { useState } from "react";
import { updateTagAsync, createTagAsync, fetchTagDepartmentReportStatusSummaryAsync, requestTagReopenAsync, approveTagReopenAsync, denyTagReopenAsync } from "@features/report/tag/services/reportTagSvc";
import { UpdateReportTagRequest, CreateReportTagRequest, RequestReportTagReopenRequest } from "@features/report/tag/types/reportTagRequests";

export function useReportTagActions() {
    const [busy, setBusy] = useState(false);

    const doTagCreate = async (nationId: number, data: CreateReportTagRequest) => {
        setBusy(true);

        const response = await createTagAsync(nationId, data);

        setBusy(false);
        return response;
    }

    const doTagUpdate = async (nationId: number, reportTagId: number, data: UpdateReportTagRequest) => {
        setBusy(true);

        const response = await updateTagAsync(nationId, reportTagId, data);

        setBusy(false);
        return response;
    };

    const doFetchDepartmentReportStatusSummary = async (nationId: number, reportTagId: number) => {
        setBusy(true);
        try {
            return await fetchTagDepartmentReportStatusSummaryAsync(nationId, reportTagId);
        } finally {
            setBusy(false);
        }
    };

    const doRequestReopen = async (nationId: number, reportTagId: number, data: RequestReportTagReopenRequest) => {
        setBusy(true);

        const response = await requestTagReopenAsync(nationId, reportTagId, data);

        setBusy(false);
        return response;
    };

    const doApproveReopen = async (nationId: number, reportTagId: number) => {
        setBusy(true);

        const response = await approveTagReopenAsync(nationId, reportTagId);

        setBusy(false);
        return response;
    };

    const doDenyReopen = async (nationId: number, reportTagId: number) => {
        setBusy(true);

        const response = await denyTagReopenAsync(nationId, reportTagId);

        setBusy(false);
        return response;
    };

    return {
        busy,
        doTagCreate,
        doTagUpdate,
        doFetchDepartmentReportStatusSummary,
        doRequestReopen,
        doApproveReopen,
        doDenyReopen,
    };
}